import { createClient } from "@supabase/supabase-js";
import { ENV } from "@/env";

if (!ENV.SUPABASE_URL || !ENV.SUPABASE_ANON) {
  console.warn("Supabase environment variables are missing. Using fallback configuration.");
}

export const supabase = createClient(ENV.SUPABASE_URL, ENV.SUPABASE_ANON, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
